import { render, staticRenderFns } from "./InventoryItem.vue?vue&type=template&id=56ca2fae&scoped=true&"
import script from "./InventoryItem.vue?vue&type=script&lang=ts&"
export * from "./InventoryItem.vue?vue&type=script&lang=ts&"
import style0 from "./InventoryItem.vue?vue&type=style&index=0&id=56ca2fae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ca2fae",
  null
  
)

export default component.exports